import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useAuthContext } from 'app/contexts/auth/context';
import { useClientTheme } from 'contexts/ThemeContext';
import { TAB_CONFIG } from './AppPresentation.constants';

function OnBoardingPage() {
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const { logoPath, brandShortName } = useClientTheme();
  const roles = user?.roles || [];
  const [loading, setLoading] = useState(false);

  // Define access rules based on roles
  const getAccessibleTabs = () => {
    if (roles.includes('manager')) return ['1', '2', '3', '4'];
    if (roles.includes('previsionnist_forecaster')) return ['2', '3', '4'];
    if (roles.includes('previsionnist_analyst')) return ['2', '3'];
    if (roles.includes('previsionnist_default')) return ['2'];
    return [];
  };

  // Add currentTab state, default to first accessible tab
  const accessibleTabs = getAccessibleTabs();

  // All defined tabs with valid route
  const allTabs = Object.keys(TAB_CONFIG).filter(
    (tabId) => TAB_CONFIG[tabId] && TAB_CONFIG[tabId].route
  );

  const [currentTab, setCurrentTab] = useState(allTabs[0]);
  const currentTabConfig = TAB_CONFIG[currentTab];

  // Check if user has access to a tab
  const handleExploreClick = () => {
    const selectedTab = TAB_CONFIG[currentTab];
    if (!selectedTab?.route || selectedTab.route === '#') return;
    setLoading(true);
    window.location.href = selectedTab.route;
  };

  return (
    <div className="grid h-screen w-full grid-rows-2">
      <div className="bg-primary-600"></div>
      <div className="bg-gray-100"></div>

      <div className="absolute flex w-full items-center justify-center px-5 lg:my-36">
        <div className="w-full max-w-4xl">
          <div className="mt-5 rounded-lg bg-white px-6 py-6 text-lg shadow-xl sm:px-10 lg:px-20">
            <div className="mb-6 flex justify-center lg:hidden">
              <img
                className="h-16 object-contain"
                src={logoPath}
                alt={`${brandShortName} Logo`}
                onError={(e) => {
                  e.target.src = '/images/logos/logo-henddu-white.png';
                }}
              />
            </div>

            <div className="hidden justify-center lg:flex">
              <img
                className="h-18 object-contain"
                src={logoPath}
                alt={`${brandShortName} Logo`}
                onError={(e) => {
                  e.target.src = '/images/logos/logo-henddu-white.png';
                }}
              />
            </div>

            <div className="// 2 colonnes par défaut (mobile) // 3 colonnes sur tablette // 4 colonnes sur desktop mt-6 grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4">
              {allTabs.map((tabId) => {
                const tab = TAB_CONFIG[tabId];
                return (
                  <TabButton
                    key={tabId}
                    title={tab.title}
                    tabId={tab.id}
                    icon={tab.icon}
                    activeIcon={tab.activeIcon}
                    currentTab={currentTab}
                    setCurrentTab={setCurrentTab}
                    className="w-full" // TabButton occupe toute la cellule
                  />
                );
              })}
            </div>

            <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 lg:gap-2">
              <div>
                <ul className="mb-10 ml-5 mt-5 list-disc text-gray-400">
                  {currentTabConfig?.features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>
                <button
                  onClick={handleExploreClick}
                  disabled={loading || currentTabConfig?.route === '#'}
                  className={`rounded-md bg-primary-700 p-2 px-8 text-white transition-colors hover:bg-primary-800 disabled:opacity-50 ${
                    currentTabConfig?.route === '#'
                      ? 'cursor-not-allowed opacity-50'
                      : 'cursor-pointer'
                  }`}
                  aria-label="Explore selected tab"
                >
                  {loading ? 'Loading...' : 'Explore'}
                </button>
              </div>

              {/* Tab image */}
              <div className="mt-6 flex justify-center lg:mt-0">
                <div className="h-[300px] w-[450px]">
                  <img
                    className="h-full w-full object-contain"
                    src={currentTabConfig?.image}
                    alt={currentTabConfig?.imageAlt || 'Aperçu'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// TabButton component
const TabButton = ({
  title,
  icon,
  activeIcon,
  tabId,
  currentTab,
  setCurrentTab,
}) => {
  const isActive = currentTab === tabId;

  return (
    <button
      onClick={() => setCurrentTab(tabId)}
      className={`border-b-4 px-6 py-4 ${isActive ? 'border-primary-600 text-primary-600 dark:border-primary-500 dark:text-primary-400' : 'border-gray-500 text-gray-400'}`}
    >
      <div className="flex justify-center">
        <img
          className="mb-2 w-10"
          src={isActive ? activeIcon : icon}
          alt={`${title} icon`}
        />
      </div>
      <span className="text-center capitalize">{title}</span>
    </button>
  );
};

export default OnBoardingPage;
